import { c as _c } from "react/compiler-runtime";
import { FaroTable } from "@components/common/faro-table/faro-table";
import { FaroTableColumnVisibilityMenu } from "@components/common/faro-table/faro-table-column-visibility-menu";
import { useMembersColumns } from "@components/table/members/members-column/use-members-columns";
import { MEMBERS_SORT_BY_MAP } from "@components/table/members/members-sort-constants";
import { MEMBERS_TABLE_COLUMN_LABELS } from "@components/table/members/members-table-constants";
import { getMemberTableTrackingSubject, getMembersSortByFromGridSortModel } from "@components/table/members/members-table-utils";
import { useHandleColumnOrderChange } from "@hooks/use-handle-column-order-change";
import { useAppSelector } from "@store/store-helper";
import { tableTypeSelector } from "@store/table/table-selector";
import { TableType } from "@utils/track-event/track-event-list";
import { useCallback } from "react";
import { useSetMemberTableType } from "@hooks/table/use-set-member-table-type";
/** Listing all the members of a subject such as a company or a project in a table */
export function MembersTable(t0) {
  const $ = _c(37);
  const {
    companyId,
    members,
    project,
    isLoading,
    tableSubject,
    group,
    bulkActionButtons,
    team,
    shouldHideCheckbox,
    sidePanelContent,
    sidePanelContentWidth,
    isSidePanelOpened,
    onRowClick,
    sortBy,
    setSortBy,
    getUniqueRowId,
    sx
  } = t0;
  const tableType = useAppSelector(tableTypeSelector);
  const t1 = companyId ?? "";
  let t2;
  if ($[0] !== group || $[1] !== project || $[2] !== t1 || $[3] !== tableSubject || $[4] !== team) {
    t2 = {
      companyId: t1,
      project,
      tableSubject,
      group,
      team
    };
    $[0] = group;
    $[1] = project;
    $[2] = t1;
    $[3] = tableSubject;
    $[4] = team;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const columns = useMembersColumns(t2);
  const handleColumnOrderChange = useHandleColumnOrderChange(tableType ?? TableType.companyMembers);
  useSetMemberTableType(tableSubject);
  const t3 = MEMBERS_SORT_BY_MAP[sortBy];
  let t4;
  if ($[6] !== t3) {
    t4 = [t3];
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const sortModel = t4;
  let t5;
  if ($[8] !== setSortBy) {
    t5 = newModel => {
      const newSortBy = getMembersSortByFromGridSortModel(newModel);
      setSortBy?.(newSortBy);
    };
    $[8] = setSortBy;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleSortModelChange = t5;
  const t6 = tableType ?? TableType.companyMembers;
  let t7;
  if ($[10] !== tableSubject) {
    t7 = getMemberTableTrackingSubject(tableSubject);
    $[10] = tableSubject;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ["user", "name"];
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = tableType ?? TableType.companyMembers;
  let t10;
  if ($[13] !== t9) {
    t10 = <FaroTableColumnVisibilityMenu labelsMap={MEMBERS_TABLE_COLUMN_LABELS} disabledColumns={t8} tableType={t9} />;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      display: "flex"
    };
    t12 = {
      width: "100%"
    };
    $[15] = t11;
    $[16] = t12;
  } else {
    t11 = $[15];
    t12 = $[16];
  }
  let t13;
  if ($[17] !== sx) {
    t13 = {
      ...sx,
      "& .MuiDataGrid-columnHeader:hover .drag-handle": t11,
      "& .MuiDataGrid-columnHeaderTitleContainerContent": t12
    };
    $[17] = sx;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== bulkActionButtons || $[20] !== columns || $[21] !== getUniqueRowId || $[22] !== handleColumnOrderChange || $[23] !== handleSortModelChange || $[24] !== isLoading || $[25] !== isSidePanelOpened || $[26] !== members || $[27] !== onRowClick || $[28] !== shouldHideCheckbox || $[29] !== sidePanelContent || $[30] !== sidePanelContentWidth || $[31] !== sortModel || $[32] !== t10 || $[33] !== t13 || $[34] !== t6 || $[35] !== t7) {
    t14 = <FaroTable entities={members} uniqueIdKey="identity" getUniqueRowId={getUniqueRowId} isLoading={isLoading} columns={columns} bulkActionButtons={bulkActionButtons} shouldHideCheckbox={shouldHideCheckbox} sidePanelContent={sidePanelContent} sidePanelContentWidth={sidePanelContentWidth} isSidePanelOpened={isSidePanelOpened} tableType={t6} onRowClick={onRowClick} sortModel={sortModel} onSortModelChange={handleSortModelChange} sortTrackingSubject={t7} filterMenuTrigger={t10} onColumnOrderChange={handleColumnOrderChange} sx={t13} />;
    $[19] = bulkActionButtons;
    $[20] = columns;
    $[21] = getUniqueRowId;
    $[22] = handleColumnOrderChange;
    $[23] = handleSortModelChange;
    $[24] = isLoading;
    $[25] = isSidePanelOpened;
    $[26] = members;
    $[27] = onRowClick;
    $[28] = shouldHideCheckbox;
    $[29] = sidePanelContent;
    $[30] = sidePanelContentWidth;
    $[31] = sortModel;
    $[32] = t10;
    $[33] = t13;
    $[34] = t6;
    $[35] = t7;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
}